module.exports = __webpack_public_path__ + "img/next.419270f3.svg";